import { memo, useEffect, useRef } from 'react';
import { CollectionPointWithI18nKey } from '../../../../types/collectionPoints';
import { getAssetUrl } from '../../../../utils/config';
import './style.scss';

type MapProps = {
  location: CollectionPointWithI18nKey;
};

const Map = ({ location }: MapProps) => {
  const mapContainerRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const { latitude, longitude } = location.displayData.coordinates;
    const map = new google.maps.Map(mapContainerRef.current!, {
      disableDefaultUI: true,
      zoom: 14,
      center: { lat: latitude, lng: longitude },
    });
    new google.maps.Marker({
      position: { lat: latitude, lng: longitude },
      map,
      icon: {
        scaledSize: new google.maps.Size(50, 50),
        url: getAssetUrl(`collectionPoints/mapPins/${location.i18nKey}Selected.svg`),
      },
    });
  }, []);

  return <div className="collection-point-detail-page__map" ref={mapContainerRef}></div>;
};

export default memo(Map);
